export default "__VITE_ASSET__Yw$46Vue__"